'use strict';
module.exports = require( './lib/u2f-api' );